import React, { Children, useState } from "react";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useController } from "react-hook-form";

// import JS files
import { useUserData } from "../../context/UserDataContext";
import MuiTheme from "./MuiTheme";

// import Others files

const MuiSelectHook = ({
  size,
  inputLabel,
  labelId,
  id,
  label,
  menuItems,
  fromApi,
  onChange,
  value,
  defaultValue,

  control,
  name,
  register,
}) => {
  let windowWidth = window.screen.width;
  const {
    field: { ref, ...restField },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: register,
    defaultValue: defaultValue,
  });

  return (
    <>
      <MuiTheme>
        <Box>
          <FormControl fullWidth size={size}>
            <InputLabel id={labelId}>{inputLabel}</InputLabel>
            <Select
              labelId={labelId}
              id={id}
              label={label}
              value={value}
              defaultValue={defaultValue}
              onChange={onChange}
              name={name} // send down the input name
              inputRef={ref} // send input ref, so we can focus on input when error appear
              error={!!error}
              {...restField} // input value
            >
              {menuItems.map((item, index) => {
                return [
                  <MenuItem value={fromApi ? item.id : item.value}>
                    {item.name}
                  </MenuItem>,
                ];
              })}
            </Select>
          </FormControl>
          {error && (
            <span className="text-sm text-red-500 mt-2">{error.message}</span>
          )}
        </Box>
      </MuiTheme>
    </>
  );
};

export default MuiSelectHook;
